<ng-container *ngIf="generatedIcon">
  <svg>
    <use [attr.href]="'assets/images/symbol-defs.svg#' + icon" style="fill: currentColor;"></use>
  </svg>
</ng-container>

<ng-container *ngIf="!generatedIcon">
  <img [src]="'assets/images/' + icon">
</ng-container>
